(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryDetailController', ProviderCountryDetailController);

    ProviderCountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProviderCountry'];

    function ProviderCountryDetailController($scope, $rootScope, $stateParams, previousState, entity, ProviderCountry) {
        var vm = this;

        vm.providerCountry = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerCountryUpdate', function(event, result) {
            vm.providerCountry = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
